<template>
	<div class="RequestDemo">
		<div class="video-section">
			<el-row>
				<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
					<div class="macbook">
						<div class="macbook-wrap">
							<img src="../../assets/images/homepage/Demo banner.jpg" />
						</div>
					</div>
				</el-col>
				<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
					<div class="right-section">
						<!-- <h2>See what Tenzo can do for you</h2> -->
						<p>
							Now boost your business profits with AI based platform for Retail
						</p>
						<p>
							<button class="text-white" @click="goToFreeTrial">
								REQUEST DEMO
							</button>
						</p>
					</div>
				</el-col>
			</el-row>
			<LoginAndFreeTrial v-if="showLoginModel" />
		</div>
	</div>
</template>

<script>
export default {
	name: "RequestDemo",
	mixins: [],
	props: [],
	data() {
		return {};
	},
	// computed: {
	// 	showLoginModel() {
	// 		// Whenever $store.state.show_login_and_freeTrial_model changes, it will cause the computed property to re-evaluate, and trigger associated DOM updates.
	// 		return this.$store.state.show_login_and_freeTrial_model;
	// 	}
	// },
	computed: {
		showLoginModel() {
			// Whenever $store.state.show_login_and_freeTrial_model changes, it will cause the computed property to re-evaluate, and trigger associated DOM updates.
			return this.$store.state.show_login_and_freeTrial_model;
		}
	},
	methods: {
		goToFreeTrial() {
			this.$store.commit("openLoginModel", true);
			this.$store.commit("showFreeTrialModel", true);
			// this.$router.push("/user-registration/start-free-trial-and-login");
		}
	}
};
</script>

<style lang="scss" scoped>
@import "./RequestDemo.scss";
@import "./RequestDemoM.scss";
</style>
